export function cityToSlug(cityName) {
  if (!cityName) return "";

  return cityName
    .toLowerCase()
    .trim()
    .replace(/\//g, "-")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-") // Collapse multiple hyphens
    // Existing transliteration logic is kept; below we extend it with umlaut handling for slug safety.
    .replace(/ž/g, "z")
    .replace(/č/g, "c")
    .replace(/š/g, "s")
    // Added per Task 1 request: umlaut variants should map to base Latin letters in slugs.
    // Even though input is lowercased above, we keep both lines for explicitness and future safety.
    .replace(/ä/g, "a")
    .replace(/ö/g, "o")
    .replace(/ü/g, "u")
    // .replace(/đ/g, "d")
    // Kept previous line commented exactly as requested before active replacement.
    .replace(/đ/g, "d");
}

export function slugToCity(slug) {
  if (!slug) return "";

  const cityMap = {
    ljubljana: "Ljubljana",
    maribor: "Maribor",
    celje: "Celje",
    kranj: "Kranj",
    koper: "Koper",
    "novo-mesto": "Novo mesto",
    // Added compatibility mapping so legacy slug with old bilingual label still resolves to the corrected name.
    "lendava-lendva": "Lendava",
    domzale: "Domžale",
    velenje: "Velenje",
    "nova-gorica": "Nova Gorica",
  };

  return cityMap[slug.toLowerCase()] || slug;
}

import regionsAndCities from "./regionAndCities.js";

export function findCityFromSlug(slug) {
  if (!slug) return null;

  const normalizedSlug = slug.toLowerCase().trim();

  for (const region of Object.values(regionsAndCities)) {
    for (const cityName of region) {
      const citySlug = cityToSlug(cityName);
      if (citySlug.toLowerCase() === normalizedSlug) {
        return cityName;
      }
    }
  }

  return slugToCity(slug);
}

// The page slug of a city name, but only for a real Slovenian municipality (else null).
// Used to turn old "?city=Trbovlje" addresses into the city's own page "/trbovlje".
export function findKnownCitySlug(cityName) {
  if (!cityName) return null;
  const slug = cityToSlug(String(cityName));
  const known = Object.values(regionsAndCities)
    .flat()
    .some((name) => cityToSlug(name) === slug);
  return known ? slug : null;
}
